import { createStore, combineReducers } from "redux";
import { language } from "./language";

export const ConfigureStore = () => {
  const store = createStore(language, { language: "eng" });
  return store;
};
